var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "esArticlesHeader" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", { staticClass: "esArticlesHeader__item__articlesEdit" }, [
      _vm._v("記事管理")
    ]),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass: "esArticlesHeader__item__button button",
        attrs: { disabled: _vm.isCapacityExcess },
        on: { click: _vm.createNewArticle }
      },
      [_c("i", { staticClass: "fi-pencil" }), _vm._v(" 新規作成")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "esArticlesHeader__item__title" }, [
      _c("i", { staticClass: "fi-page" }),
      _vm._v(" 記事作成")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }